/**
 * Quickview modal, triggered by clicking a product image — on the
 * collection grid or the cart page.
 *
 * Each trigger carries data-quickview-target pointing at its modal's
 * unique id, rather than relying on DOM position (e.g. "the next
 * sibling"). Position-based lookup breaks once the same product can
 * have more than one trigger pointing at it, which happens on the cart
 * page — two different sizes of the same product are two different
 * cart lines, each with its own trigger, but they'd share one modal id
 * if it were keyed only by product. (In practice each cart line gets
 * its own modal instance anyway, keyed by line, so this mostly matters
 * for robustness rather than a specific bug — but id-based lookup is
 * correct either way, and position-based lookup is fragile by nature.)
 *
 * Opening moves the modal to be a direct child of <html> rather than
 * leaving it nested wherever it started. Same reasoning as the cart
 * toast fix: if any ancestor in the page's DOM tree has a CSS
 * transform, filter, or similar applied, position:fixed stops being
 * relative to the viewport and starts being relative to that ancestor
 * instead — which can silently break or hide a modal. Moving to
 * <html> sidesteps the problem entirely.
 */
(function () {
  function initQuickviewModal(modal) {
    var slides = modal.querySelectorAll('[data-quickview-slide]');
    var thumbs = modal.querySelectorAll('[data-quickview-thumb]');
    var prevBtn = modal.querySelector('[data-quickview-prev]');
    var nextBtn = modal.querySelector('[data-quickview-next]');
    var closeEls = modal.querySelectorAll('[data-quickview-close]');
    var current = 0;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === current);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current + 1);
      });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(i);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        closeQuickview(modal);
      });
    });

    modal.querySelector('.quickview-modal__panel').addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  function openQuickview(modal) {
    document.documentElement.appendChild(modal);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeQuickview(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function init() {
    document.querySelectorAll('[data-quickview-modal]').forEach(initQuickviewModal);

    document.querySelectorAll('[data-quickview-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var targetId = trigger.getAttribute('data-quickview-target');
        if (!targetId) return;
        var modal = document.getElementById(targetId);
        if (modal) openQuickview(modal);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-quickview-modal]:not([hidden])').forEach(function (modal) {
          closeQuickview(modal);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
